import { memo } from 'react';
import FloorsFilter from '../../FilterRealty/FloorsFilter';
import PriceFilter from '../../FilterRealty/PriceFilter';
import SearchFilter from '../../FilterRealty/SearchFilter';
import SelectFilter from '../../FilterRealty/SelectFilter';
import { getSelectPropsCreator } from '../utils';
import DatepickerDropdown from '../../core/DatepickerDropdown';

const FixationTableFilterForm = memo(props => {
  const {
    filter,
    filterData,
    handleFilter,
    setFilterAndExclude
  } = props;

  const createSelectProps = getSelectPropsCreator(props);
  if (!filterData) return
  return (
    <div className="sf__filter form">
      <SearchFilter
        placeholder="ФИО клиента, телефон"
        handleChange={v => handleFilter('query', v)}
        value={filter.query ?? ""}
        wrapperClass="sf__filter-item"
      />
      <SelectFilter
        {...createSelectProps("builder")}
        data={{ title: "Застройщик", identity: "builder" }}
        wrapperClass="sf__filter-item"

      />
      <DatepickerDropdown
        onChange={v => handleFilter("dateCreate", { min: v.startDate, max: v.endDate })}
        value={{ startDate: filter.dateCreate?.min, endDate: filter.dateCreate?.max }}
        label="Дата добавления"
        clearFilters={() => setFilterAndExclude("dateCreate")}
        motivationIntervalFilter
      />
      {/* <DatepickerDropdown
        onChange={(value) => handleFilter(value, "dateFixationFrom")}
        value={filter.dateFixationFrom || {
          startDate: null,
          endDate: null,
        }}
        label="Зафиксирован"
        clearFilters={() => setFilterAndExclude("dateFixationFrom")}
        motivationIntervalFilter
      /> */}
      <DatepickerDropdown
        onChange={v => handleFilter("dateFixationTo", { min: v.startDate, max: v.endDate })}
        value={{ startDate: filter.dateFixationTo?.min, endDate: filter.dateFixationTo?.max }}
        label="Окончание фиксации"
        clearFilters={() => setFilterAndExclude("dateFixationTo")}
        motivationIntervalFilter
      />
      <SelectFilter
        {...createSelectProps("status")}
        data={{ title: "Статус", identity: "status" }}
        wrapperClass="sf__filter-item"
      />
      <SelectFilter
        {...createSelectProps("agent")}
        data={{ title: "Агент", identity: "agent" }}
        wrapperClass="sf__filter-item"
      />
      {/* <SelectFilter
        {...createSelectProps("title")}
        data={{ title: "Клиент", identity: "title" }}
        wrapperClass="sf__filter-item"
        valueKey="value"
      /> */}

    </div>
  );
});

export default FixationTableFilterForm;